import { useState, useEffect } from 'react';
import { isPassiveSupport } from '@utilities/passiveSupport';

export function useActiveElement() {
  const [active, setActive] = useState<Element | null>();
  const handleFocusIn = () => {
    setActive(document.activeElement);
  };
  useEffect(() => {
    setActive(document.activeElement);
  }, []);
  useEffect(() => {
    const options = isPassiveSupport() ? { passive: true } : false;
    document.addEventListener('focusin', handleFocusIn, options);
    return () => {
      document.removeEventListener('focusin', handleFocusIn);
    };
  }, []);
  return active;
}
